/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

const lineSolid = (
	<SVG xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
		<Path d="M5 11.25h14v1.5H5z" />
	</SVG>
);

export default lineSolid;
